import $api from '../http';
import { AxiosResponse } from 'axios';
import { AuthResponse } from '../models/response/AuthResponse';

export default class AuthService {
  static async login(
    email: string,
    password: string
  ): Promise<AxiosResponse<AuthResponse>> {
    return $api.post<AuthResponse>('/login', { email, password });
  }

  static async registration(
    name: string,
    surname: string,
    email: string,
    password: string,
    userType: number
  ): Promise<AxiosResponse<AuthResponse>> {
    return $api.post<AuthResponse>('/registration', {
      name,
      surname,
      email,
      password,
      userType,
    });
  }

  static async logout(): Promise<void> {
    return $api.post('/logout');
  }
}
